module.exports = {
      id: "google-usage",
      viewBox: "0 0 533.5 544.3",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#google",
      toString: function () {
        return this.url;
      }
    }